import { useState, useEffect, useCallback } from 'react';
import { supabase } from '@/integrations/supabase/client';

export type FounderPhase = 'phase1' | 'phase2' | 'regular';

export interface FounderOfferState {
  phase: FounderPhase;
  price: number;
  spotsLeft: number;
  phase1Sold: number;
  phase2Sold: number;
  isLoading: boolean;
}

export function useFounderOffer(): FounderOfferState {
  const [state, setState] = useState<FounderOfferState>({
    phase: 'regular',
    price: 17,
    spotsLeft: 0,
    phase1Sold: 0,
    phase2Sold: 0,
    isLoading: true,
  });

  const fetchOffer = useCallback(async () => {
    try {
      const { data, error } = await (supabase as any)
        .from('founder_offer_state')
        .select('*')
        .limit(1)
        .maybeSingle();

      if (error || !data) {
        setState(prev => ({ ...prev, isLoading: false }));
        return;
      }

      const { phase1_cap, phase2_cap, phase1_price, phase2_price, regular_price, phase1_sold, phase2_sold } = data;

      let phase: FounderPhase = 'regular';
      let price = regular_price;
      let spotsLeft = 0;

      if (phase1_sold < phase1_cap) {
        phase = 'phase1';
        price = phase1_price;
        spotsLeft = phase1_cap - phase1_sold;
      } else if (phase2_sold < phase2_cap) {
        phase = 'phase2';
        price = phase2_price;
        spotsLeft = phase2_cap - phase2_sold;
      }

      setState({ phase, price, spotsLeft, phase1Sold: phase1_sold, phase2Sold: phase2_sold, isLoading: false });
    } catch {
      setState(prev => ({ ...prev, isLoading: false }));
    }
  }, []);

  useEffect(() => {
    fetchOffer();
  }, [fetchOffer]);

  return state;
}
